module.exports = __webpack_public_path__ + "static/media/search.4d58c39b.svg";